import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { capturePartnerEvent } from "../utils/analytics";
import F1_PartnerLandingPageMay from "../modules/partnersView/pages/F1_PartnerLandingPageMay";
import PartnerApplicationForm from "../modules/partnersView/pages/F2_PartnerApplicationForm";
import PartnerDashboard from "../modules/partnersView/pages/F3_PartnerDashboard";
import LandingPage from "../modules/partnersView/pages/LandingPage";
import PartnerStatus from "../modules/partnersView/pages/F4_PartnerStatusPage";
import AdminOverview from "../modules/adminView/pages/A1_AdminOverview";
import AdminApplicationsList from "../modules/adminView/pages/A2_AdminApplicationsList";
import AdminApplicationDetail from "../modules/adminView/pages/A3_AdminApplicationDetail";
import AdminPartnersList from "../modules/adminView/pages/A4_AdminPartnersList";
import AdminPartnerDetail from "../modules/adminView/pages/A5_AdminPartnerDetail";
import AdminCommissions from "../modules/adminView/pages/A6_AdminCommissions";
import AdminPayouts from "../modules/adminView/pages/A7_AdminPayouts";
import AdminPayoutDetail from "../modules/adminView/pages/A8_AdminPayoutDetail";
import AdminMilestones from "../modules/adminView/pages/A9_AdminMilestones";
import AdminComingSoonInterest from "../modules/adminView/pages/A10_AdminComingSoonInterest";
import AdminRouteGuard from "../components/AdminRouteGuard";

const RedirectApplyType = () => {
  const { type } = useParams();
  return <Navigate to={`/partners/apply/${type}/`} replace />;
};

function CatchAll() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin/partners")) {
    return (
      <Navigate
        to={pathname.replace(/^\/admin\/partners/, "/partners/admin")}
        replace
      />
    );
  }
  return <Navigate to="/become-a-partner/" replace />;
}

function PartnerPageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    capturePartnerEvent("partner_page_viewed", { path: pathname });
  }, [pathname]);
  return null;
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <PartnerPageTracker />
      <Routes>
        <Route
          path="/become-a-partner/"
          element={
            // eslint-disable-next-line react/jsx-pascal-case -- module export name
            <F1_PartnerLandingPageMay />
          }
        />
        <Route
          path="/become-a-partner"
          element={<Navigate to="/become-a-partner/" replace />}
        />
        <Route path="/partners/apply/:type/" element={<PartnerApplicationForm />} />
        <Route path="/partners/apply/:type" element={<RedirectApplyType />} />
        <Route
          path="/partners/apply/"
          element={<Navigate to="/partners/apply/ecosystem/" replace />}
        />
        <Route
          path="/partners/apply"
          element={<Navigate to="/partners/apply/ecosystem/" replace />}
        />
        <Route path="/partners/dashboard/" element={<PartnerDashboard />} />
        <Route
          path="/partners/dashboard"
          element={<Navigate to="/partners/dashboard/" replace />}
        />
        <Route path="/partners/video-intro/" element={<LandingPage />} />
        <Route
          path="/partners/video-intro"
          element={<Navigate to="/partners/video-intro/" replace />}
        />
        <Route path="/partners/status/" element={<PartnerStatus />} />
        <Route
          path="/partners/status"
          element={<Navigate to="/partners/status/" replace />}
        />
        <Route path="/" element={<Navigate to="/become-a-partner/" replace />} />
        <Route path="/apply/:type" element={<RedirectApplyType />} />
        <Route
          path="/dashboard"
          element={<Navigate to="/partners/dashboard/" replace />}
        />

        <Route
          path="/partners/admin"
          element={
            <AdminRouteGuard>
              <AdminOverview />
            </AdminRouteGuard>
          }
        />
        <Route
          path="/partners/admin/applications"
          element={
            <AdminRouteGuard>
              <AdminApplicationsList />
            </AdminRouteGuard>
          }
        />
        <Route
          path="/partners/admin/applications/:id"
          element={
            <AdminRouteGuard>
              <AdminApplicationDetail />
            </AdminRouteGuard>
          }
        />
        <Route
          path="/partners/admin/partners"
          element={
            <AdminRouteGuard>
              <AdminPartnersList />
            </AdminRouteGuard>
          }
        />
        <Route
          path="/partners/admin/partners/:id"
          element={
            <AdminRouteGuard>
              <AdminPartnerDetail />
            </AdminRouteGuard>
          }
        />
        <Route
          path="/partners/admin/commissions"
          element={
            <AdminRouteGuard>
              <AdminCommissions />
            </AdminRouteGuard>
          }
        />
        <Route
          path="/partners/admin/payouts"
          element={
            <AdminRouteGuard>
              <AdminPayouts />
            </AdminRouteGuard>
          }
        />
        <Route
          path="/partners/admin/payouts/:id"
          element={
            <AdminRouteGuard>
              <AdminPayoutDetail />
            </AdminRouteGuard>
          }
        />
        <Route
          path="/partners/admin/milestones"
          element={
            <AdminRouteGuard>
              <AdminMilestones />
            </AdminRouteGuard>
          }
        />
        <Route
          path="/partners/admin/interest"
          element={
            <AdminRouteGuard>
              <AdminComingSoonInterest />
            </AdminRouteGuard>
          }
        />

        <Route path="*" element={<CatchAll />} />
      </Routes>
    </BrowserRouter>
  );
}
